<template>
  <div class="realMockExam">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'RealMockExam'
  }
</script>